import { FormattedMessage } from 'react-intl';
import type { ReactNode } from 'react';
import cx from 'clsx';
import { usePdfPreviewContext } from '../../pdf-preview-context.tsx';
import styles from './reason.module.css';

interface ReasonProps {
  reason?: string;
}

export function Reason({ reason }: ReasonProps): ReactNode {
  const { displayLanguage, type } = usePdfPreviewContext();

  if (type === 'credit-note' && reason) {
    return (
      <p data-testid="credit-note-pdf-preview-reason">
        <span className={cx('body-1-bold', styles.label)}>
          <FormattedMessage
            id="pdf-preview.credit-note.reason-credit-note"
            values={{ language: displayLanguage }}
          />
        </span>
        <span className="body-1">{reason}</span>
      </p>
    );
  }

  return null;
}
